import Logger from '../../logging/logger';
import { search } from '../search-form';

const onMapNavigateLinkClick = async ( ctx, event ) => {
    const { originalEvent } = event.detail;

    let reset = false;
    let isGeocoded = false;

    if ( originalEvent.target.dataset.reset && originalEvent.target.dataset.reset === 'true' ) {
        reset = true;
    }

    Logger.info( '[map] Handling Map Naviation Link', {
        reset,
        originalEvent,
    } );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:collapse:collapse-all', { bubbles: true } ) );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:search-this-area:deactivate', { bubbles: true } ) );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:remove-area', {
        bubbles: true,
        detail: {
            search: false,
        },
    } ) );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:draw-your-search:deactivate', {
        bubbles: true,
        detail: {
            search: false,
        },
    } ) );

    if ( reset ) {
        ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:reset', {
            bubbles: true,
            detail: {
                form: ctx.baseForm,
                searchOptions: {
                    focusMapToSearch: true,
                },
            },
        } ) );
        return;
    }

    if ( originalEvent.target.dataset.isGeocoded && originalEvent.target.dataset.isGeocoded === 'true' ) {
        isGeocoded = true;
    }

    if ( !reset && ( !( 'type' in originalEvent.target.dataset ) || !( 'id' in originalEvent.target.dataset ) ) ) {
        throw new Error( 'no type/id specified' );
    }

    const locationIDInputs = document.querySelectorAll( '.property-search-form input[name=locationId][type=hidden]' );

    if ( locationIDInputs.length === 0 ) {
        return;
    }

    if ( !reset ) {
        locationIDInputs.forEach( ( input ) => {
            input.value = originalEvent.target.dataset.id;
            input.dataset.id = originalEvent.target.dataset.id || 0;
            input.dataset.type = originalEvent.target.dataset.type || '';
            input.dataset.isIsland = originalEvent.target.dataset.isIsland || '';
            input.dataset.isGeocoded = originalEvent.target.dataset.isGeocoded || '';
            input.dataset.longitude = originalEvent.target.dataset.longitude || '';
            input.dataset.latitude = originalEvent.target.dataset.latitude || '';
            input.dataset.location = originalEvent.target.dataset.location || '';
        } );
    }

    if ( !isGeocoded ) {
        const radiusInputs = document.getElementsByName( 'radius' );

        for ( let i = 0; i < radiusInputs.length; i++ ) {
            radiusInputs[ i ].value = '';

            if ( radiusInputs[ i ].nodeName === 'SELECT' ) {
                radiusInputs[ i ].classList.remove( 'has-value' );
            }
        }
    }

    return search( ctx, null, {
        from: ctx.baseForm,
        to: ctx.popupForm,
        forceReset: reset,
    } );
};

const detectMapNavigateLinkClick = ( ctx, event ) => {
    if ( !event.target.matches( '.twc__map-search-update-link' ) ) {
        return;
    }

    event.preventDefault();

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:click-navigateLink', {
        bubbles: true,
        detail: {
            originalEvent: event,
        },
    } ) );
};

export {
    onMapNavigateLinkClick,
    detectMapNavigateLinkClick,
};
